import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=f98e21bc"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=f98e21bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports